"use client"

import React, {useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import {Divider} from "@mantine/core";
import PrivatePolicyTwContent from "@/app/(index)/privacy-policy/tw-content";
import PrivatePolicyEnContent from "@/app/(index)/privacy-policy/en-content";
import PIPSTwContent from "@/app/(index)/personal-information-protection-statement/tw-content";
import PIPSEnContent from "@/app/(index)/personal-information-protection-statement/en-content";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

export default function Page() {
    const { fontSize, lang } = useGlobalStateStore();
    const [tab, setTab] = useState<number>(1);
    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }

    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                <Bread name_c="個人資料蒐集告知聲明" name_e="Personal Data Collection Agreement"/>
                <div className="w-[1250px] mx-auto mb-[100px]">
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] text-[#5b5b5b] text-[35px] font-bold">
                        {lang == "tw" && "個人資料蒐集告知聲明"}
                        {lang == "en" && "Personal Data Collection Agreement"}
                    </div>


                    <div className="mt-[40px] text-[#8d7f4c] text-[46px] font-bold">
                        { lang == "tw" && (<div className="leading-[56px]">財團法人國家實驗研究院科技政策研究與資訊中心<br/>隱私保護及網站安全政策</div>) }
                        { lang == "en" && (<div className="text-[36px] leading-[42px]">Science Technology Policy Research and Information Center, NIAR<br/>Personal Data Collection Notice</div>) }
                    </div>

                    <Divider mt={30} my={35}/>

                    { lang == "tw" && <PIPSTwContent/> }
                    { lang == "en" && <PIPSEnContent/> }
                </div>
            </div>
            <Footer/>
        </div>
    );
}
